<template>
  <section class="grid-legend">
    <div class="grid-legend-controls">
      <button class="grid-control green" @click="allOn">All On</button>
      <button class="grid-control orange" @click="allOff">All Off</button>
      <button class="grid-control brown" @click="hideLegend = !hideLegend">
        {{ legendControlText }} Legend
      </button>
      <slot />
    </div>
    <transition name="legend">
      <div v-show="!hideLegend">
        <table>
          <tr
            v-for="col in columns"
            :key="col.field"
            :class="{ tooltip: col.disabled }"
          >
            <td>
              <toggle-button
                ref="toggle"
                :labels="{ checked: 'ON', unchecked: 'OFF' }"
                :value="col.value === false ? false : true"
                :disabled="col.disabled"
                :width="62"
                :height="20"
                :color="{ checked: '#3b6c4c', unchecked: '#b7b4a2' }"
                :switch-color="'white'"
                :font-size="12"
                class="toggle-button"
                @change="toggleCol(col)"
              />
            </td>
            <td>
              <span v-if="!col.disabled"
                ><strong v-html="col.field"></strong>:
                {{ col.headerTooltip }}
              </span>
              <span v-else>
                <span class="missing-col" v-html="col.field"></span>
                <span class="missing-col">:</span>
                {{ col.headerTooltip }}
                <span class="tooltiptext">Coming soon</span>
              </span>
            </td>
          </tr>
        </table>
      </div>
    </transition>
  </section>
</template>

<script>
import consola from "consola";

function createDummyLegendEntry(columns, field, tooltip) {
  const copy = Object.assign(
    {},
    columns.find((c) => c.field === "YM")
  );
  copy.field = field;
  copy.headerTooltip = tooltip;
  copy.value = false;
  copy.disabled = true;
  columns.push(copy);
}

export default {
  props: {
    cols: {
      type: [],
      default: () => ({}),
    },
    gridColumnApi: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      columns: [],
      hideLegend: false,
      legendControlText: "Collapse",
    };
  },
  watch: {
    hideLegend(newValue, _oldValue) {
      if (newValue) {
        this.legendControlText = "Expand";
      } else {
        this.legendControlText = "Collapse";
      }
    },
  },
  created() {
    this.columns = this.$props.cols.filter(
      (c) => !(c.field === "county" || c.field === "year")
    );
    createDummyLegendEntry(
      this.columns,
      "FQ",
      "Firearm Permit Quotas (excludes, landowner, archery, and youth)"
    );
    createDummyLegendEntry(this.columns, "MQ", "Muzzleloader Permit Quotas");
    createDummyLegendEntry(this.columns, "FI", "Firearm Permits Issued");
    createDummyLegendEntry(this.columns, "MI", "Muzzleloader Permits Issued");

    createDummyLegendEntry(this.columns, "CWDS", "Number of CWD Samples Taken");
    createDummyLegendEntry(this.columns, "CWD", "Number of CWD Cases");
    createDummyLegendEntry(this.columns, "EHD", "Number of EHD Cases Reported");

    createDummyLegendEntry(
      this.columns,
      "COUNTY M<sup>2</sup>",
      "County Size (Square Miles)"
    );
    createDummyLegendEntry(
      this.columns,
      "HABITAT",
      "Amount of Deer Habitat in a County (Square Miles)"
    );
    createDummyLegendEntry(
      this.columns,
      "AACCESS",
      "Amount of Deer Habitat Not Within a 100 yards of a Dwelling"
    );
    createDummyLegendEntry(
      this.columns,
      "FACCESS",
      "Amount of Deer Habitat Not Within a 400 yards of a Dwelling"
    );
    createDummyLegendEntry(
      this.columns,
      "HABHAR",
      "Density of Deer Harvest Within Deer Habitat"
    );
    createDummyLegendEntry(
      this.columns,
      "COUHAR",
      "Density of Deer Harvest Within a County"
    );
  },
  methods: {
    toggleCol(col) {
      const columnState = this.$props.gridColumnApi.getColumnState();
      // consola.info(columnState);
      const column = columnState.find((c) => c.colId === col.field);
      if (column) {
        const hide = !column.hide;
        this.$props.gridColumnApi.applyColumnState({
          state: [
            {
              colId: col.field,
              hide: hide,
            },
          ],
        });
      }
    },
    allOn() {
      consola.info("allOn");
      const toggles = this.$refs.toggle.filter((c) => !c.disabled);
      toggles.forEach((c) => (c.toggled = true));
      const columnState = this.$props.gridColumnApi.getColumnState();
      this.columns.forEach((col) => {
        const column = columnState.find((c) => c.colId === col.field);
        if (column) {
          if (column.hide) {
            this.$props.gridColumnApi.applyColumnState({
              state: [
                {
                  colId: col.field,
                  hide: false,
                },
              ],
            });
          }
        }
      });
    },
    allOff() {
      consola.info("allOff");
      const toggles = this.$refs.toggle.filter((c) => !c.disabled);
      toggles.forEach((c) => (c.toggled = false));
      const columnState = this.$props.gridColumnApi.getColumnState();
      this.columns.forEach((col) => {
        const column = columnState.find((c) => c.colId === col.field);
        if (column) {
          if (!column.hide) {
            this.$props.gridColumnApi.applyColumnState({
              state: [
                {
                  colId: col.field,
                  hide: true,
                },
              ],
            });
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.toggle-button {
  letter-spacing: 0.1rem;
  margin-right: 0.5rem;
}
.grid-legend-controls {
  margin: 20px 0;
}
.grid-control {
  cursor: pointer;
  font-family: "Gill Sans W03", sans-serif;
  font-weight: 700;
  border: 0;
  border-radius: 10px;
  padding: 3px 8px;
  // letter-spacing: 0.1;
  text-transform: uppercase;
  margin-right: 1rem;
  color: white;
  &:hover {
    background-color: #5d3021;
  }
}
.green {
  background-color: #3b6c4c;
}
.orange {
  background-color: #eb9e08;
}
.missing-col {
  color: #b7b4a2;
  font-weight: bold;
}
.brown {
  background-color: #a25926;
}

.legend-enter-active,
.legend-leave-active {
  overflow: hidden;
  max-height: 1500px;
  transition: max-height 0.7s linear;
}
.legend-enter,
.legend-leave-to {
  overflow: hidden;
  max-height: 0;
  transition: max-height 0.7s linear;
}

/* Tooltip container */
.tooltip {
  position: relative;
  // display: inline-block;
  // border-bottom: 1px dotted black; /* If you want dots under the hoverable text */
}

/* Tooltip text */
.tooltip .tooltiptext {
  // visibility: hidden;
  opacity: 0;
  transition: 0.3s opacity;
  width: 120px;
  background-color: #b7b4a2;
  color: #fff;
  text-align: center;
  padding: 2px 0;
  border-radius: 10px;
  margin-left: 1rem;

  /* Position the tooltip text - see examples below! */
  position: absolute;
  top: -2px;
  z-index: 1;
}
.tooltiptext:before {
  content: "";
  position: absolute;
  border: 10px solid #b7b4a2;
  border-color: transparent #b7b4a2 transparent transparent;
  opacity: 0;
  transition: 0.3s opacity;
  transform: translateX(-33px) translateY(0px);
}
.tooltip:hover .tooltiptext:before,
.tooltip:hover .tooltiptext:after {
  // display: block;
  opacity: 1;
}

/* Show the tooltip text when you mouse over the tooltip container */
.tooltip:hover .tooltiptext {
  // visibility: visible;
  opacity: 1;
}
</style>
